import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { IconWrapper } from './IconWrapper';

const WHATSAPP_NUMBER = '+91 93022 55300';
const WHATSAPP_LINK = 'https://wa.me/919302255300';

export const WhatsAppButton: React.FC = () => {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noreferrer"
      className="group fixed bottom-6 left-8 z-40 p-4 rounded-full bg-white text-green-600 shadow-2xl shadow-green-500/30 border border-green-200 dark:border-green-500/30 dark:bg-slate-900 dark:text-green-400 hover:-translate-y-1 transition-all duration-300"
      aria-label={`Chat on WhatsApp with FirstLogic (${WHATSAPP_NUMBER})`}
    >
      <span className="flex items-center justify-center w-8 h-8 rounded-full bg-green-500 text-white group-hover:scale-105 transition-transform">
        <IconWrapper icon={FaWhatsapp} className="w-4 h-4" />
      </span>
    </a>
  );
};

